/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
  } from "@vlinder-web/plugin-agent-service-react";
  // import config from "../config/issueCredential.config.json";
  // import notification from "../config/notifications.config.json";
  import axios from "axios";
  import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
  import { UNLIST_PORTFOLIO } from "../graphql";
  import { VApplication } from "../../../application";
  import {useCollection} from "../provider";
  
  const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
  };
  
  export interface IUnlistPortfolioMethods extends IPluginMethodMap {
    getUnlistPortfolio(args: any): Promise<any>;
  }
  
  export interface UnlistPortfolioProps {
    portfolioId:string;
  }
  
  export class UnlistPortfolioService implements IAgentPlugin {
    readonly methods: IUnlistPortfolioMethods;
    constructor() {
      this.methods = {
        getUnlistPortfolio: this.getUnlistPortfolio.bind(this),
      };
    }
  
    async getUnlistPortfolio(args: UnlistPortfolioProps) {
      console.log(`args in issue credential`, args);
      const {portfolioTempId} = useCollection();
      const graphqlModule = getGraphQLModule();
      const client = graphqlModule.getClient("graphql-gateway");

      try {
        console.log('unlist portfolio args', args);
        if (client) {
          const res = await client.mutate({
            mutation: UNLIST_PORTFOLIO,
            variables: {
                portfolioId:portfolioTempId,
                status:"APPROVED"
            },
            fetchPolicy: "no-cache",
          });
          if (res?.data?.unlistPortfolio) {
            console.log(`Update status`, res);
            return res?.data?.unlistPortfolio;
          }
        }
      } catch (err: any) {
        // console.log("error in issue credential", err?.message);
        throw err;
      }
    }
  }